// /src/components/ContainerPrices.js
import { useState, useEffect, useContext, useRef } from "react";
import { Link, useSearchParams, useLocation } from "react-router-dom";
import axios from "axios";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@material-ui/core";

import "../InvoicesManagement.scss";
import CustomInput from "../../components/CustomInput";
import { useTranslation } from "react-i18next";
import CustomButton from "../../components/CustomButton";

import addIcon from "../../assets/add_icon.png";
import searchIcon from "../../assets/search_icon.png";
import nextIcon from "../../assets/next_icon.png";
import previousIcon from "../../assets/previous_icon.png";
import saveIcon from "../../assets/save_icon.png";
import closeIcon from "../../assets/close_icon.png";
import editIcon from "../../assets/edit_icon.png";

import UserSection from "../../components/UserSection";
import { DataContext } from "../../utils/DataContext";
import InformationBox from "../../components/InformationBox";
import Modal from "../../components/Modal";
import classes from "../../components/Modal.module.css";
import useLanguage from "../../utils/useLanguage";
import Dropdown from "../../components/Dropdown";
import BackToDashboard from "../../components/BackToDashboard";
import Loader from "../../components/Loader";
import { UserAuth } from "../../utils/AuthContext";
import SectionDivider from "../../components/SectionDivider";
import ErrorBox from "../../components/ErrorBox";
import { onlyNums } from "../../utils/OnlyNums";
import { formatDate } from "../../utils/toDate";

// service function
import {
  getMultiContainerInvoices,
  getCompanyBankAccounts,
  getSupplierBankAccounts,
} from "../../services/bank/bankServices";
import HotdropdownV2 from "../../components/HotdropdownV2";
import CustomInputWithUnit from "../../components/CustomInputWithUnit";
import CopyButton from "../../components/CopyButton";
import SearchFilter from "../../components/SearchFilter";
import CustomCheckbox from "../../components/CustomCheckbox";
import { checkIfBlocked } from "../../services/subcompanies/subcompaniesServices";
import PaymentStatusBadge from "../ai-organization/PaymentStatusBadge";

const BANKS = {
  BAGHDAD: "مصرف بغداد",
};

const BankApplications = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();

  const didInitPageFromUrl = useRef(false);
  const didAutoSetSupplier = useRef(false);

  const [selectedRow, setSelectedRow] = useState(null);
  const [showRowModal, setShowRowModal] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedStatus, setSelectedStatus] = useState({
    id: "",
    nameInAr: "selectAll",
  });
  const [activeSearchParams, setActiveSearchParams] = useState(null);
  const [toHongKong, setToHongKong] = useState(false);
  const [appServiceOrImport, setAppServiceOrImport] = useState(false);

  const [initialLoadComplete, setInitialLoadComplete] = useState(false);
  const [applicationsLoading, setApplicationsLoading] = useState(false);

  const [isSubCompanyBlocked, setIsSubCompanyBlocked] = useState(false);

  // Handler for opening the row info modal
  const rows = [
    {
      title: "invoiceNumber",
      value: "invoiceNumber",
    },
    {
      title: "invoiceDate",
      value: "invoiceDate",
    },
    { title: "creator", value: "bankAppCreator" },
    { title: "bank", value: "bank" },
    {
      title: "paidPercentage",
      value: "paidPercentage",
    },
    {
      title: "Actions",
      value: "Actions",
    },
  ];

  const { t } = useTranslation("general");
  const { currentDirection } = useLanguage();

  const [data, setData] = useState([]);

  const [multiBanksForSupplier, setMultiBanksForSupplier] = useState(false);
  const [loadingSupplierBank, setLoadingSupplierBank] = useState(false);

  const [invoicesCurrentPage, setInvoicesCurrentPage] = useState(1);
  const [invoicesTotalPages, setInvoicesTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(1);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    limit: 5,
  });

  const [supplierBankPagination, setSupplierBankPagination] = useState({
    currentPage: 1,
    totalPages: 1,
  });

  const [pageCurrentSupplier, setPageCurrentSupplier] = useState({});
  const [pageSelectedSubCompany, setPageSelectedSubCompany] = useState({});

  const [banks, setBanks] = useState([]);
  const [branches, setBranches] = useState([]);
  const [bankAccounts, setBankAccounts] = useState([]);
  const [supplierBankAccounts, setSupplierBankAccounts] = useState([]);

  // SubCompany bank
  const [selectedBank, setSelectedBank] = useState({
    title: t("chooseABank"),
    value: "",
  });

  // SubCompany branch
  const [selectedBranch, setSelectedBranch] = useState({
    title: t("chooseABranch"),
    value: "",
  });

  // SubCompany bankAccount
  const [selectedBankAccount, setSelectedBankAccount] = useState({
    title: t("chooseABankAccount"),
    value: "",
  });

  // states for the refrence number and payment date
  const [refrenceNumber, setRefrenceNumber] = useState(null);
  const [paymentDate, setPaymentDate] = useState(new Date());

  const [supplierBank, setSupplierBank] = useState({
    title: t("chooseABank"),
    value: "",
  });

  const [supplierBranch, setSupplierBranch] = useState({
    title: t("chooseABranch"),
    value: "",
  });
  const [nonIraqiBanks, setNonIraqiBanks] = useState([]);
  const [supplierBranches, setSupplierBranches] = useState([]);

  const [selectedSupplierBankAccount, setSelectedSupplierBankAccount] =
    useState({
      title: t("chooseABankAccount"),
      value: "",
    });

  const [bankAccountFields, setBankAccountFields] = useState({
    purposeOfPayment: "",
    paymentPercentage: "",
    invoiceAmount: 100,
    currentPaid: 0,
  });

  // Search states
  const [selectedTitle, setSelectedTitle] = useState({
    title: t("invoiceNumber"),
    value: "invoiceNumber",
  });
  const [searchQuery, setSearchQuery] = useState(null);
  const [selectedDate, setSelectedDate] = useState(formatDate(new Date()));

  const spanStyles = currentDirection === "rtl" ? classes.shortSpan : null;

  const isBankExist = selectedRow?.subCompanyBankAccount?.bank ? true : false;

  const {
    error,
    setError,
    loading,
    setLoading,
    setNetworkError,
    setSelectedSupplier,
    selectedSupplier,
    selectedSubCompany,
  } = useContext(DataContext);

  const { userData } = useContext(UserAuth);

  const [loadingModal, setLoadingModal] = useState(false);

  const checkIfSubCompanyBlocked = async (bankId, subCompanyId) => {
    try {
      const response = await checkIfBlocked(subCompanyId, bankId);

      if (response.status === 200) {
        setIsSubCompanyBlocked(response.data.isBlocked);
        if (response.data.isBlocked) {
          setError("subCompanyIsBlockedByBank");
        } else {
          setError(null);
        }
      }
    } catch (error) {
      console.error("Error checking if subcompany is blocked:", error);
      setError("Failed to check block status");
    }
  };

  const getAllIraqiBanks = async (page, limit, undefined, searchQuery) => {
    try {
      const banks = await axios.get(
        `${process.env.REACT_APP_URL}/api/bank/getSubCompanyBanks`,
        {
          headers: {
            Authorization: `Bearer ${userData?.token}`,
          },
          params: {
            page: page || pagination.currentPage,
            limit: limit || pagination.limit,
            searchQuery: searchQuery,
            isIraqi: true,
            subCompanyId: selectedRow?.subCompany.id,
          },
        },
      );

      if (banks.status === 200) {
        setBanks((prev) => [...prev, ...banks?.data?.banks]);
        return banks;
      }
    } catch (error) {
      setError(error?.response?.message || "Failed");
      console.error("Failed to create the supplier", error);
    }
  };

  const getAllNonIraqiBanks = async (page, limit, undefined, searchQuery) => {
    try {
      const banks = await axios.get(
        `${process.env.REACT_APP_URL}/api/bank/getSubCompanyBanks`,
        {
          headers: {
            Authorization: `Bearer ${userData?.token}`,
          },
          params: {
            page: page || pagination.currentPage,
            limit: limit || pagination.limit,
            searchQuery: searchQuery,
            isIraqi: false,
            supplierId: selectedRow?.supplier.id,
          },
        },
      );

      if (banks.status === 200) {
        setNonIraqiBanks((prev) => [...prev, ...banks?.data?.banks]);
        return banks;
      }
      return [];
    } catch (error) {
      setError(error?.response?.message || "Failed");
      console.error("Failed to get non-Iraqi banks", error);
    }
  };

  // UPDATED: Replace fetchInvoices with new endpoint
  const fetchInvoices = async (
    searchType,
    searchQuery,
    invoicesCurrentPage = 1,
  ) => {
    try {
      // setLoading(true);
      setApplicationsLoading(true);

      const params = {
        page: invoicesCurrentPage,
        limit: 5,
      };

      if (searchType && searchQuery) {
        params.type = searchType;

        if (selectedTitle.value === "date") {
          if (searchQuery.startDate) params.startDate = searchQuery.startDate;
          if (searchQuery.endDate) params.endDate = searchQuery.endDate;
        } else if (selectedTitle.value === "status") {
          if (searchQuery.status) params.status = searchQuery.status;
        } else {
          params.query = searchQuery[selectedTitle?.value] || searchQuery;
        }
      }

      if (selectedSubCompany?.id && selectedSubCompany?.id !== "All") {
        params.subCompanyId = selectedSubCompany.id;
      }

      if (selectedSupplier?.id && selectedSupplier?.id !== "All") {
        params.supplierId = selectedSupplier.id;
      } else {
        params.supplierId = "All";
      }

      const response = await getMultiContainerInvoices(params);

      if (response && response.status === 200) {
        const data = response.data;

        if (!selectedSupplier?.id) {
          setSelectedSupplier(response.data?.currentSupplier);
          setPageCurrentSupplier(response.data?.currentSupplier);
          setPageSelectedSubCompany(selectedSubCompany);
        } else {
          setPageCurrentSupplier(response.data?.currentSupplier);
          setPageSelectedSubCompany(selectedSubCompany);
        }
        setData(data?.invoices);
        setTotalRecords(data?.totalInvoices);
        setInvoicesCurrentPage(data?.currentPage);
        setInvoicesTotalPages(data?.totalPages);
        setInitialLoadComplete(true);
      }
    } catch (error) {
      setNetworkError(true);
      console.error("Error fetching data:", error);
      setInitialLoadComplete(true);
    } finally {
      // setLoading(false);
      setApplicationsLoading(false);
    }
  };

  const handleSearchType = async (type) => {
    setSelectedTitle(type);
    setSearchQuery("");
    setStartDate("");
    setEndDate("");
    setInvoicesCurrentPage(1);
    setSelectedStatus({ id: "", nameInAr: t("selectAll") });
    setActiveSearchParams(null);
  };

  const handleSearch = async (queryOverride) => {
    const isOverride = typeof queryOverride === "string";

    const params = {};
    if (selectedTitle.value === "date") {
      if (startDate) params.startDate = startDate;
      if (endDate) params.endDate = endDate;
    } else if (selectedTitle.value === "status") {
      if (selectedStatus.id) params.status = selectedStatus.id;
    } else {
      const query = isOverride ? queryOverride : searchQuery;
      if (query) {
        params[selectedTitle.value] = query;
      }
    }

    setActiveSearchParams(Object.keys(params).length > 0 ? params : null);
    setInvoicesCurrentPage(1);
  };

  const handleCancel = (modal) => {
    setSelectedRow(null);
    setShowRowModal(false);
    setLoadingModal(false);
    setIsSubCompanyBlocked(false);

    setSelectedBank({
      title: t("chooseABank"),
      value: "",
    });
    setSelectedBranch({
      title: t("chooseABranch"),
      value: "",
    });
    setSelectedBankAccount({
      title: t("chooseABankAccount"),
      value: "",
    });

    setSupplierBank({
      title: t("chooseABank"),
      value: "",
    });

    setSupplierBranch({
      title: t("chooseABranch"),
      value: "",
    });

    setSelectedSupplierBankAccount({
      title: t("chooseABankAccount"),
      value: "",
    });

    setRefrenceNumber(null);
    setPaymentDate(new Date());

    setBankAccountFields((prev) => ({
      ...prev,
      purposeOfPayment: "",
      paymentPercentage: "",
      currentPaid: 0,
    }));

    setBanks([]);
    setNonIraqiBanks([]);
    setBranches([]);
    setBankAccounts([]);
    setSupplierBankAccounts([]);
    setError("");
  };

  useEffect(() => {
    if (!userData?.token) return;

    const pageFromUrl = parseInt(
      new URLSearchParams(location.search).get("page") || "1",
      10,
    );

    if (!didInitPageFromUrl.current) {
      didInitPageFromUrl.current = true;

      if (
        !Number.isNaN(pageFromUrl) &&
        pageFromUrl > 0 &&
        pageFromUrl !== invoicesCurrentPage
      ) {
        setInvoicesCurrentPage(pageFromUrl);
        return;
      }
    }

    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.set("page", String(invoicesCurrentPage));
        return next;
      },
      { replace: true },
    );

    fetchInvoices(
      activeSearchParams ? selectedTitle.value : null,
      activeSearchParams,
      invoicesCurrentPage,
    );
  }, [
    userData?.token,
    invoicesCurrentPage,
    selectedTitle?.value,
    JSON.stringify(activeSearchParams || {}),
    selectedSubCompany?.id,
    selectedSupplier?.id,
  ]);

  const handleSelectBank = (bank, state) => {
    const { id, name, branch: branches } = bank;
    if (state === "subCompany") {
      setSelectedBank({ title: name, value: id });
      setSelectedBranch({ title: t("chooseABranch"), value: "" });
      setSelectedBankAccount({ title: t("chooseABankAccount"), value: "" });
      setBranches(branches);

      setBankAccounts(
        selectedRow?.subCompany?.bankAccount
          ?.filter((account) => {
            return account?.bankId === id;
          })
          ?.map((validAccount) => {
            return {
              id: validAccount?.id,
              name: validAccount?.accountNumber,
            };
          }),
      );

      checkIfSubCompanyBlocked(id, selectedRow?.subCompany?.id);
    } else if (state === "supplier") {
      setSupplierBank({ title: name, value: id });
      setSupplierBranch({ title: t("chooseABranch"), value: "" });
      setSelectedSupplierBankAccount({
        title: t("chooseABankAccount"),
        value: "",
      });
      setSupplierBranches(branches);

      setSupplierBankAccounts(
        selectedRow?.supplier?.bankAccount
          ?.filter((account) => account?.bankId === id)
          ?.map((validAccount) => ({
            id: validAccount?.id,
            name: validAccount?.accountNumber,
          })),
      );
    } else {
      console.error("invalid state value", state);
    }
  };

  const handleSelectBranch = (branch, state) => {
    const { name, id } = branch;
    if (state === "subCompany") {
      setSelectedBranch({ title: name, value: id });
    } else if (state === "supplier") {
      setSupplierBranch({ title: name, value: id });
    } else {
      console.error("invalid state value", state);
    }
  };

  const handleSelectBankAccount = (bankAccount, state) => {
    const { name, id } = bankAccount;

    if (state === "subCompany") {
      setSelectedBankAccount({ title: name, value: id });
    } else if (state === "supplier") {
      setSelectedSupplierBankAccount({ title: name, value: id });
    } else {
      console.error("invalid state value", state);
    }
  };

  const [errorText, setErrorText] = useState("");

  // Check for payment amount error
  useEffect(() => {
    const currentPaid = parseInt(bankAccountFields.currentPaid);

    if (!currentPaid || isNaN(currentPaid) || currentPaid === 0) {
      setErrorText("faultyAmount");
    } else if (
      currentPaid + selectedRow?.totalPaid >
      selectedRow.amountForSupplier
    ) {
      setErrorText("faultyAmount");
    } else {
      setErrorText(null);
    }
  }, [bankAccountFields.currentPaid, selectedRow]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setBankAccountFields((prev) => ({ ...prev, [name]: value }));
  };

  const handleGenerateFiles = async () => {
    try {
      setLoadingModal(true);
      const token = localStorage.getItem("token");

      let data = {};

      if (selectedRow?.allowBankChange) {
        data = {
          invoiceId: selectedRow?.id,
          userId: parseFloat(localStorage.getItem("userId")), // For subCompany
          companyBankId:
            selectedBank?.value || selectedRow?.subCompanyBankAccount?.bank?.id,

          companyBranchId:
            selectedBranch?.value ||
            selectedRow?.subCompanyBankAccount?.branch?.id,

          companyBankAccountId: selectedRow?.subCompanyBankAccount?.id
            ? selectedRow?.subCompanyBankAccount?.id
            : selectedBankAccount?.value,

          // For supplier
          supplierBankId:
            supplierBank.value || selectedRow.supplierBankAccount?.bank?.id,

          supplierBankAccountId:
            selectedSupplierBankAccount?.value ||
            selectedRow?.supplierBankAccount?.id,

          supplierBranchId:
            supplierBranch.value || selectedRow.supplierBankAccount?.branch?.id,

          purposeOfPayment: bankAccountFields?.purposeOfPayment,
          paymentPercentage:
            (Number(bankAccountFields?.currentPaid) /
              selectedRow?.amountForSupplier) *
            100,

          isApplicationBank: true,

          checks: {
            transferType: bankAccountFields?.transferType,
            fee: bankAccountFields?.fee,
          },
          toHongKong: toHongKong,
          isTransactionService: appServiceOrImport,

          refrenceNumber: refrenceNumber,
          paymentDate: paymentDate,
        };
      } else {
        data = {
          invoiceId: selectedRow?.id,
          userId: parseFloat(localStorage.getItem("userId")),

          // For subCompany
          companyBankId: isBankExist
            ? selectedRow.subCompanyBankAccount?.bank?.id
            : selectedBank?.value || "",
          companyBranchId: isBankExist
            ? selectedRow.subCompanyBankAccount?.branch?.id
            : selectedBranch?.value,
          companyBankAccountId: isBankExist
            ? selectedRow.subCompanyBankAccount?.id
            : selectedBankAccount?.value,

          // For supplier
          supplierBankAccountId: selectedSupplierBankAccount?.value,
          supplierBankId: isBankExist
            ? selectedRow.supplierBankAccount?.bank?.id
            : supplierBank.value,
          supplierBranchId: isBankExist
            ? selectedRow.supplierBankAccount?.branch?.id
            : supplierBranch.value,

          purposeOfPayment: bankAccountFields?.purposeOfPayment,
          paymentPercentage:
            (Number(bankAccountFields?.currentPaid) /
              selectedRow?.amountForSupplier) *
            100,

          isApplicationBank: true,
          checks: {
            transferType: bankAccountFields?.transferType,
            fee: bankAccountFields?.fee,
          },
          toHongKong: toHongKong,
          isTransactionService: appServiceOrImport,

          refrenceNumber: refrenceNumber,
          paymentDate: paymentDate,
        };
      }

      if (
        !data.invoiceId ||
        !data.companyBankId ||
        !data.purposeOfPayment ||
        !data.companyBranchId ||
        !data.companyBankAccountId
      ) {
        setError("emptyInputFields");
        return;
      }

      const invoiceNum = selectedRow?.invoiceNumber || "unknown";
      const amountForSupplier = selectedRow?.amountForSupplier || "0";
      const currency = selectedRow?.supplier.currency || "unknown";
      const zipFileName = `${invoiceNum}-${amountForSupplier}${currency}.zip`;

      let res;

      if (selectedBank.title === BANKS.BAGHDAD) {
        res = await axios.post(
          `${process.env.REACT_APP_URL}/generatePermit`,
          data,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            responseType: "blob",
          },
        );
      } else {
        res = await axios.post(
          `${process.env.REACT_APP_URL}/originalGeneratePermit`,
          data,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            responseType: "blob",
          },
        );
      }

      const blob = new Blob([res.data], { type: "application/zip" });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = zipFileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      if (res.status === 200) {
        fetchInvoices();
        setLoadingModal(false);
        setError("");
        setShowRowModal(false);

        setSelectedBank({
          title: t("chooseABank"),
          value: "",
        });
        setSelectedBranch({
          title: t("chooseABranch"),
          value: "",
        });
        setSelectedBankAccount({
          title: t("chooseABankAccount"),
          value: "",
        });

        setSupplierBank({
          title: t("chooseABank"),
          value: "",
        });

        setSupplierBranch({
          title: t("chooseABranch"),
          value: "",
        });

        setSelectedSupplierBankAccount({
          title: t("chooseABankAccount"),
          value: "",
        });

        setBankAccountFields({
          purposeOfPayment: "",
          paymentPercentage: "",
          invoiceAmount: selectedRow?.invoiceAmount,
          previousPaid: "",
          currentPaid: "",
          paymentDate: "",
        });
      }
    } catch (error) {
      setNetworkError(true);
      console.error("Error downloading files:", error);
      setError("Download failed");
    } finally {
      setLoadingModal(false);
    }
  };

  function calculatePercentage(part, base) {
    const total = part + base;

    if (total === 0) {
      return 0;
    }

    const percentage = (part / total) * 100;

    return Math.round(percentage * 100) / 100;
  }

  const handleRowButtonClick = async (row) => {
    setSelectedRow(row);
    const isBankExist = row?.subCompanyBankAccount?.bank ? true : false;
    if (isBankExist) {
      setSelectedBank({
        title: row?.subCompanyBankAccount?.bank?.name,
        value: row?.subCompanyBankAccount?.bank?.id,
      });
      setSelectedBranch({
        title: row?.subCompanyBankAccount?.branch?.name,
        value: row?.subCompanyBankAccount?.branch?.id,
      });
      setSelectedBankAccount({
        title: row?.subCompanyBankAccount?.accountNumber,
        value: row?.subCompanyBankAccount?.accountNumber,
      });

      setSupplierBank({
        title: row?.supplierBankAccount?.bank?.name,
        value: row?.supplierBankAccount?.bank?.id,
      });
      setSupplierBranch({
        title: row?.supplierBankAccount?.branch?.name,
        value: row?.supplierBankAccount?.branch?.id,
      });

      setSelectedSupplierBankAccount({
        title: row?.supplierBankAccount?.accountNumber,
        value: row?.supplierBankAccount?.id,
      });
    }
    setShowRowModal(true);

    try {
      setLoadingSupplierBank(true);
      const [companyResponse, supplierResponse] = await Promise.all([
        getCompanyBankAccounts(row.subCompany.id),
        getSupplierBankAccounts(row.supplier.id),
      ]);

      if (
        companyResponse &&
        companyResponse.status === 200 &&
        supplierResponse &&
        supplierResponse.status === 200
      ) {
        const companyBankAccounts = companyResponse.data;
        const supplierBankAccounts = supplierResponse.data;

        setSelectedRow((prev) => ({
          ...prev,
          subCompany: {
            ...prev?.subCompany,
            bankAccount: companyBankAccounts,
          },
          supplier: {
            ...prev?.supplier,
            bankAccount: supplierBankAccounts,
          },
        }));

        if (supplierBankAccounts?.length > 0) {
          setMultiBanksForSupplier(true);
        } else {
          setMultiBanksForSupplier(false);
        }
      }
    } catch (error) {
      console.error("Error fetching bank accounts:", error);
      setError("Failed to load bank accounts");
    } finally {
      setLoadingSupplierBank(false);
    }
  };

  const downloadFilesStyles =
    !selectedBank?.value ||
    !selectedBranch.value ||
    !selectedBankAccount?.value ||
    !bankAccountFields.purposeOfPayment;
  const canAddPayment =
    selectedRow?.allowBankChange && !selectedRow?.canAddPayment;

  const allowBankChange = selectedRow?.allowBankChange;

  const searchTitles = [
    {
      title: t("invoiceNumber"),
      value: "invoiceNumber",
    },
    {
      title: t("Date"),
      value: "date",
    },
    {
      title: t("status"),
      value: "status",
    },
  ];

  const statusOptions = [
    { id: "", nameInAr: t("selectAll") },
    {
      id: "completed",
      nameInAr: t("completed") || "completed",
    },
    { id: "uncompleted", nameInAr: t("incomplete") || "incomplete" },
  ];

  const isInvalidPayment =
    parseInt(bankAccountFields.currentPaid) === 0 ||
    bankAccountFields.currentPaid === "" ||
    parseInt(bankAccountFields.currentPaid) + selectedRow?.totalPaid >
      selectedRow?.amountForSupplier;

  const isBaghdadBankIncomplete =
    selectedBank.title === BANKS.BAGHDAD &&
    (!bankAccountFields.fee || !bankAccountFields.transferType);

  const cantGenerateFiles =
    loadingModal ||
    downloadFilesStyles ||
    !selectedRow?.canAddPayment ||
    isInvalidPayment ||
    isBaghdadBankIncomplete;

  const currency = selectedRow?.supplier?.bankAccount?.find(
    (account) => account.id === selectedSupplierBankAccount?.value,
  )?.accountCurrency;

  return (
    <>
      <main className="e-container">
        <div className="u-margin--top_400">
          <UserSection page="noCustomerInvoices" />
        </div>

        <div className="invoice-table-container">
          {/* Search & filtering */}
          <div className="c-search-bar u-margin--bottom_500">
            <section className="c-search-bar-label-input">
              <label>
                {t("searchTitle")} {t(selectedTitle?.title)}:
              </label>
              {selectedTitle.value === "date" ? (
                <div className="o-column-row-switcher o-column--gap-size_300">
                  <CustomInput
                    name="startDate"
                    title={t("from")}
                    type="date"
                    thick
                    onChange={(date) => {
                      setStartDate(date?.target?.value);
                    }}
                    resetSearch={() => {
                      setStartDate("");
                    }}
                    value={formatDate(startDate)}
                  />
                  <CustomInput
                    name="endDate"
                    title={t("to")}
                    type="date"
                    thick
                    onChange={(date) => {
                      setEndDate(date?.target?.value);
                    }}
                    resetSearch={() => {
                      setEndDate("");
                    }}
                    value={formatDate(endDate)}
                  />
                </div>
              ) : selectedTitle.value === "status" ? (
                <>
                  <Dropdown
                    options={statusOptions}
                    selected={selectedStatus}
                    setSelected={setSelectedStatus}
                    thick
                    nameInAr={true}
                  />
                </>
              ) : (
                <div className="u-width--min-width_230">
                  <CustomInput
                    placeholder={`${t("searchTitle")} ${t(selectedTitle?.title)}`}
                    value={searchQuery}
                    onChange={(e) => {
                      setSearchQuery(e.target.value);
                    }}
                    resetSearch={() => {
                      setSearchQuery("");
                      handleSearch("");
                    }}
                    thick
                    flex
                  />
                </div>
              )}
            </section>
            <div className="o-row o-row--gap-size_400">
              <SearchFilter
                options={searchTitles}
                selected={selectedTitle}
                setSelected={handleSearchType}
                thick
              />
              <CustomButton
                title={t("search")}
                onClick={handleSearch}
                icon={searchIcon}
                iconSize={15}
              />
            </div>
          </div>

          {applicationsLoading && <Loader />}

          {!applicationsLoading && data.length > 0 && (
            <>
              <TableContainer component={Paper}>
                <Table className="c-table">
                  <TableHead>
                    <TableRow>
                      {rows.map((row, index) => {
                        if (row.title === "invoiceDate") {
                          return (
                            <TableCell
                              key={index}
                              className="bold-text cell-title "
                            >
                              {t(row.title)}
                            </TableCell>
                          );
                        }

                        if (
                          userData?.userType !== "orgUser" &&
                          row.title === "Actions"
                        ) {
                          return;
                        } else {
                          return (
                            <TableCell
                              key={index}
                              className="bold-text cell-title"
                            >
                              {t(row.title)}
                            </TableCell>
                          );
                        }
                      })}
                    </TableRow>
                  </TableHead>
                  <TableBody className="table-body">
                    {data?.map((row, index) => (
                      <TableRow
                        key={index}
                        className={
                          row.canceled || row.archived
                            ? "canceled-invoice"
                            : "updated-invoice"
                        }
                      >
                        <TableCell>
                          {row?.applicationBank?.name === "مصرف بغداد" ? (
                            <Link
                              className="link t-bold_bold"
                              to={`/bankApplications/${row?.id}/payments`}
                            >
                              <p className="u-center-text">
                                {row?.invoiceNumber}
                              </p>
                            </Link>
                          ) : (
                            <span className="t-bold_bold">
                              <p className="u-center-text">
                                {row?.invoiceNumber}
                              </p>
                            </span>
                          )}
                        </TableCell>

                        <TableCell
                          className="cell"
                          style={{ height: "50px", minWidth: "145px" }}
                        >
                          {row.date || row.modifiedAt
                            ? new Date(row.date || row.modifiedAt)
                                .toISOString()
                                .split("T")[0]
                            : ""}
                        </TableCell>

                        <TableCell className="cell">
                          {row?.createdBy ? (
                            <p>{row?.createdBy}</p>
                          ) : (
                            <p className="neutral-value">{t("notFound")}</p>
                          )}
                        </TableCell>

                        <TableCell className="cell">
                          {row?.applicationBank ? (
                            <p>{row?.applicationBank?.name}</p>
                          ) : (
                            <p className="neutral-value">{t("notFound")}</p>
                          )}

                          {row?.companyStatus &&
                            row?.applicationBank?.nameWithNoSpace ===
                              "مصرفبغداد" && (
                              <div className={""}>
                                {row?.latestPaymentDetail?.transactionNumber ? (
                                  <div
                                    className={"o-column o-column--gap-size_50"}
                                  >
                                    {row?.generalBadgeStatus === "REJECTED" && (
                                      <PaymentStatusBadge
                                        status={row?.generalBadgeStatus}
                                      />
                                    )}
                                    <p className="u-center-text u-padding_0 u-margin_0">
                                      {t("transferNumber") + ":"}
                                    </p>
                                    <span className="t-bold_bold royal-green">
                                      {
                                        row?.latestPaymentDetail
                                          ?.transactionNumber
                                      }
                                    </span>
                                  </div>
                                ) : (
                                  <PaymentStatusBadge
                                    status={
                                      row?.generalBadgeStatus === "NOT_STARTED"
                                        ? "SENT"
                                        : row?.generalBadgeStatus ===
                                              "SENT_TO_POLICIES" &&
                                            localStorage.getItem(
                                              "organizationType",
                                            ) !== "BANK"
                                          ? "PRIMARY_CHECK"
                                          : row?.generalBadgeStatus
                                    }
                                  />
                                )}
                              </div>
                            )}
                        </TableCell>

                        <TableCell
                          className="cell"
                          style={{
                            color:
                              Math.round(
                                calculatePercentage(
                                  row?.totalPaid,
                                  row?.remainingAmount,
                                ),
                                4,
                              ) < 100
                                ? ""
                                : "green",
                          }}
                        >
                          {Number(
                            parseFloat(
                              calculatePercentage(
                                row?.totalPaid,
                                row?.remainingAmount,
                              ),
                            ).toFixed(2),
                          )}
                          %
                        </TableCell>

                        {userData.userType === "orgUser" ? (
                          <TableCell className="cell">
                            {row.canEditPayment ? (
                              <CustomButton
                                variant="blank"
                                title={t("edit")}
                                onClick={() => handleRowButtonClick(row)}
                                icon={editIcon}
                                iconSize={20}
                              />
                            ) : (
                              <CustomButton
                                variant="blank"
                                title={t("generateApplication")}
                                onClick={() => handleRowButtonClick(row)}
                                icon={addIcon}
                                iconSize={20}
                                disabled={
                                  row.totalPaid === row.amountForSupplier
                                    ? true
                                    : false
                                }
                              />
                            )}
                          </TableCell>
                        ) : null}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <section className="pagination">
                <div className="pagination-buttons">
                  <CustomButton
                    variant="blank"
                    title={t("previous")}
                    onClick={() => setInvoicesCurrentPage((prev) => prev - 1)}
                    disabled={invoicesCurrentPage === 1}
                    icon={currentDirection === "ltr" ? previousIcon : nextIcon}
                    iconSize={15}
                  />
                  <span className="pagination-location">
                    {t("page")}: {invoicesCurrentPage} - {invoicesTotalPages}
                  </span>
                  <CustomButton
                    title={t("next")}
                    variant="blank"
                    onClick={() => setInvoicesCurrentPage((prev) => prev + 1)}
                    disabled={invoicesCurrentPage === invoicesTotalPages}
                    icon={currentDirection === "ltr" ? nextIcon : previousIcon}
                    iconSize={15}
                    reverseIcon
                  />
                </div>
                <div className="pagination-buttons">
                  <span className="pagination-location">
                    {t("totalRecords")}: {totalRecords}
                  </span>
                </div>
              </section>
            </>
          )}

          {!loading &&
            data.length === 0 &&
            initialLoadComplete &&
            !applicationsLoading && (
              <InformationBox>
                <p>{t("noTransactions")}</p>
              </InformationBox>
            )}

          {showRowModal && selectedRow && (
            <Modal
              title={t("bankApplicationInformation")}
              onClose={handleCancel}
              footer={
                <>
                  {loadingModal ? <Loader /> : null}
                  <section className={classes.actions}>
                    <CustomButton
                      title={t("downloadFiles")}
                      icon={saveIcon}
                      iconSize={16}
                      onClick={handleGenerateFiles}
                      disabled={cantGenerateFiles}
                    />
                    <CustomButton
                      title={t("cancel")}
                      onClick={handleCancel}
                      variant="blank"
                      icon={closeIcon}
                      iconSize={14}
                    />
                  </section>
                </>
              }
            >
              {!selectedRow.canAddPayment && (
                <InformationBox>{t("youCannotAddPayment")}</InformationBox>
              )}
              {isBankExist && selectedRow.allowBankChange && (
                <InformationBox>
                  {t("thereIsAlreadyBankPayment")}
                </InformationBox>
              )}
              <div className={classes.flexableForm}>
                <div className="o-row o-row--gap-size_300">
                  <span className={classes.longSpan}>{t("sender")}:</span>
                  <span className="t-bold_bold">
                    {selectedRow?.subCompany?.name}
                  </span>
                </div>
                <div className="o-row o-row--gap-size_300">
                  <span className={classes.longSpan}>{t("recipient")}:</span>
                  <span className="t-bold_bold">
                    {selectedRow?.supplier?.name || t("No supplier available")}
                  </span>
                </div>
                <SectionDivider title="senderBankAccountInfo" />
                {error && <ErrorBox>{t(error)}</ErrorBox>}
                <div className={classes.inputContainer}>
                  <span className={spanStyles}>{t("bankName")}: </span>
                  <HotdropdownV2
                    initOptions={banks}
                    setOptions={setBanks}
                    selected={selectedBank}
                    setSelected={(bank) => handleSelectBank(bank, "subCompany")}
                    getData={getAllIraqiBanks}
                    optionsName={"banks"}
                    flex
                    disabled={!allowBankChange}
                  />
                </div>

                <div className={classes.inputContainer}>
                  <span className={spanStyles}>{t("branch")}: </span>
                  <HotdropdownV2
                    initOptions={branches || []}
                    setOptions={setBranches}
                    selected={selectedBranch}
                    setSelected={(branch) =>
                      handleSelectBranch(branch, "subCompany")
                    }
                    flex
                    disabled={!allowBankChange || isSubCompanyBlocked}
                  />
                </div>
                <div className={classes.inputContainer}>
                  <span className={spanStyles}>{t("accountNumber")}: </span>
                  <HotdropdownV2
                    initOptions={bankAccounts || []}
                    setOptions={setBankAccounts}
                    selected={selectedBankAccount}
                    setSelected={(accountNumber) =>
                      handleSelectBankAccount(accountNumber, "subCompany")
                    }
                    flex
                    disabled={!allowBankChange || isSubCompanyBlocked}
                  />
                </div>

                <SectionDivider title="receiverBankAccountInfo" />

                {loadingSupplierBank && !multiBanksForSupplier ? (
                  <Loader />
                ) : multiBanksForSupplier ? (
                  <>
                    <div className={classes.inputContainer}>
                      <span className={spanStyles}>{t("bankName")}: </span>
                      <HotdropdownV2
                        initOptions={nonIraqiBanks}
                        setOptions={setNonIraqiBanks}
                        selected={supplierBank}
                        setSelected={(bank) =>
                          handleSelectBank(bank, "supplier")
                        }
                        getData={getAllNonIraqiBanks}
                        optionsName={"nonIraqiBanks"}
                        flex
                        disabled={!allowBankChange}
                      />
                    </div>
                    <div className={classes.inputContainer}>
                      <span className={spanStyles}>{t("branch")}: </span>
                      <HotdropdownV2
                        initOptions={supplierBranches || []}
                        setOptions={setSupplierBranches}
                        selected={supplierBranch}
                        setSelected={(branch) =>
                          handleSelectBranch(branch, "supplier")
                        }
                        flex
                        disabled={!allowBankChange}
                      />
                    </div>
                    <div className={classes.inputContainer}>
                      <span className={spanStyles}>{t("accountNumber")}: </span>
                      <HotdropdownV2
                        initOptions={supplierBankAccounts || []}
                        setOptions={setSupplierBankAccounts}
                        selected={selectedSupplierBankAccount}
                        setSelected={(accountNumber) =>
                          handleSelectBankAccount(accountNumber, "supplier")
                        }
                        flex
                        disabled={!allowBankChange}
                      />
                    </div>
                  </>
                ) : (
                  <InformationBox>
                    <p>{t("noReceiverBankAccounts")}</p>
                  </InformationBox>
                )}

                <SectionDivider title="dateAndSerialDetails" />
                <div className="o-column o-column--gap-size_300">
                  <div className="u-width_full-width o-row o-row--vertical-align_center o-row--gap-size_500">
                    <span className="t-bold_semi-bold u-width-specific_100">
                      {t("Date")}:{" "}
                    </span>
                    <CustomInput
                      name="date"
                      type="date"
                      flex={true}
                      value={formatDate(paymentDate)}
                      onChange={(e) => setPaymentDate(e.target.value)}
                    />
                  </div>
                  <div className="u-width_full-width o-row o-row--vertical-align_center o-row--gap-size_500 ">
                    <span className="t-bold_semi-bold u-width-specific_100">
                      {t("refrenceNumber")}:{" "}
                    </span>
                    <CustomInput
                      name="number"
                      type="text"
                      flex={true}
                      value={refrenceNumber}
                      onChange={(e) => setRefrenceNumber(e.target.value)}
                    />
                  </div>
                </div>
                <SectionDivider title="paymentDetails" />
                <div
                  className={`${classes.inputContainer} o-row--vertical-align_center`}
                >
                  <span
                    className={`${spanStyles} u-width_full-width u-flex_flex-1`}
                  >
                    {t("invoiceAmount")}:
                  </span>
                  <span
                    className={`${spanStyles} o-row u-width_full-width o-row--vertical-align_center o-row--gap-size_300 t-bold_bold`}
                  >
                    {selectedRow?.amount}
                    <CopyButton text={selectedRow?.amountForSupplier} />
                  </span>
                </div>
                <div
                  className={`${classes.inputContainer} o-row--vertical-align_center`}
                >
                  <span
                    className={`${spanStyles} u-width_full-width u-flex_flex-1`}
                  >
                    {t("previousPaid")}:
                  </span>
                  <span
                    className={`${spanStyles} o-row u-width_full-width o-row--vertical-align_center o-row--gap-size_300 t-bold_bold`}
                  >
                    {!selectedRow.allowBankChange ? selectedRow?.totalPaid : 0}{" "}
                    {currency}
                  </span>
                </div>
                <div
                  className={`${classes.inputContainer} o-row--vertical-align_center`}
                >
                  <span
                    className={`${spanStyles} u-width_full-width u-flex_flex-1`}
                  >
                    {t("currentPaid")}:
                  </span>
                  <div className="o-row u-width_full-width o-row--vertical-align_center o-row--gap-size_300">
                    <CustomInputWithUnit
                      errorText={errorText}
                      name="currentPaid"
                      value={bankAccountFields?.currentPaid}
                      onChange={handleInputChange}
                      onKeyDown={(e) => onlyNums(e)}
                      flex={true}
                      unit={currency}
                      disabled={
                        !selectedRow?.canAddPayment ||
                        selectedRow.fullPaymentCompleted
                      }
                    />
                  </div>
                </div>

                <div
                  className={`${classes.inputContainer} o-row--vertical-align_center`}
                >
                  <span
                    className={`${spanStyles} u-width_full-width u-flex_flex-1`}
                  >
                    {t("paymentPercentage")}:
                  </span>
                  <span
                    className={`${spanStyles} o-row u-width_full-width o-row--vertical-align_center o-row--gap-size_300 t-bold_bold`}
                  >
                    {parseFloat(
                      (
                        (Number(bankAccountFields?.currentPaid) /
                          selectedRow?.amountForSupplier +
                          (!selectedRow?.allowBankChange
                            ? selectedRow?.totalPaid
                            : 0) /
                            selectedRow?.amountForSupplier) *
                        100
                      ).toFixed(2),
                    ) || "0"}
                    %
                  </span>
                </div>

                {selectedBank.title === BANKS.BAGHDAD && (
                  <>
                    <div
                      className={`o-column-row-switcher o-row--gap-size_300`}
                    >
                      <span className={`${spanStyles} u-width--min-width_120`}>
                        {t("transferType")}:
                      </span>
                      <div className="o-row o-row--gap-size_500">
                        <div className="o-row o-row--gap-size_200 o-row--vertical-align_center o-row--horizontal-align_center">
                          <CustomCheckbox
                            label={t("external")}
                            checked={
                              bankAccountFields?.transferType === "external"
                            }
                            onChange={(e) => {
                              handleInputChange({
                                target: {
                                  name: "transferType",
                                  value: e.target.checked ? "external" : "",
                                },
                              });
                            }}
                            id="external"
                          />
                          <label htmlFor="external">{t("external")}</label>
                        </div>

                        <div className="o-row o-row--gap-size_200 o-row--vertical-align_center o-row--horizontal-align_center">
                          <CustomCheckbox
                            label={t("internal")}
                            checked={
                              bankAccountFields?.transferType === "internal"
                            }
                            onChange={(e) => {
                              handleInputChange({
                                target: {
                                  name: "transferType",
                                  value: e.target.checked ? "internal" : "",
                                },
                              });
                            }}
                            id="internal"
                          />
                          <label htmlFor="internal">{t("insideIraq")}</label>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                <div
                  className={`${classes.inputContainer} o-row o-row--vertical-align_start`}
                >
                  <span className={spanStyles}>{t("purposeOfPayment")}: </span>
                  <div className="u-width_full-width">
                    <CustomInput
                      name="purposeOfPayment"
                      value={bankAccountFields?.purposeOfPayment}
                      onChange={handleInputChange}
                      flex={true}
                      type="textarea"
                      disabled={
                        !selectedRow?.canAddPayment ||
                        selectedRow.fullPaymentCompleted
                      }
                    />
                  </div>
                </div>
                {selectedBank.title === BANKS.BAGHDAD && (
                  <>
                    <div
                      className={"o-column-row-switcher  o-row--gap-size_300"}
                    >
                      <span className={`${spanStyles} u-width--min-width_150`}>
                        {t("correspondentBankFeesForOurBank")}:
                      </span>
                      <div className="o-row o-row--gap-size_500">
                        <div className="o-row o-row--gap-size_200 o-row--vertical-align_center o-row--horizontal-align_center">
                          <CustomCheckbox
                            label={t("beneficiary")}
                            checked={bankAccountFields?.fee === "beneficiary"}
                            onChange={(e) => {
                              handleInputChange({
                                target: {
                                  name: "fee",
                                  value: e.target.checked ? "beneficiary" : "",
                                },
                              });
                            }}
                            id="beneficiary"
                          />
                          <label htmlFor="beneficiary">
                            {t("beneficiary")}
                          </label>
                        </div>

                        <div className="o-row o-row--gap-size_200 o-row--vertical-align_center o-row--horizontal-align_center">
                          <CustomCheckbox
                            label={t("remitter")}
                            checked={bankAccountFields?.fee === "remitter"}
                            onChange={(e) => {
                              handleInputChange({
                                target: {
                                  name: "fee",
                                  value: e.target.checked ? "remitter" : "",
                                },
                              });
                            }}
                            id="remitter"
                          />
                          <label htmlFor="remitter">{t("remitter")}</label>
                        </div>
                      </div>
                    </div>

                    <div
                      className={
                        "o-column-row-switcher  o-row--gap-size_300 u-margin--bottom_400"
                      }
                    >
                      <span className={`${spanStyles} u-width--min-width_150`}>
                        {t("toHongKong")}:
                      </span>
                      <div className="o-row o-row--gap-size_500">
                        <div className="o-row o-row--gap-size_200 o-row--vertical-align_center o-row--horizontal-align_center">
                          <CustomCheckbox
                            label={t("yes")}
                            checked={toHongKong}
                            onChange={(e) => {
                              setToHongKong(e.target.checked);
                            }}
                            id="toHongKong"
                          />
                          <label htmlFor="toHongKong">{t("yes")}</label>
                        </div>
                      </div>
                    </div>

                    <div
                      className={
                        "o-column-row-switcher  o-row--gap-size_300 u-margin--bottom_400"
                      }
                    >
                      <span className={`${spanStyles} u-width--min-width_150`}>
                        {t("appServiceOrImport")}:
                      </span>

                      <div className="o-row o-row--gap-size_500">
                        <div className="o-row o-row--gap-size_200 o-row--vertical-align_center o-row--horizontal-align_center">
                          <CustomCheckbox
                            label={t("yes")}
                            checked={appServiceOrImport}
                            onChange={(e) => {
                              setAppServiceOrImport(e.target.checked);
                            }}
                            id="appServiceOrImport"
                          />
                          <label htmlFor="appServiceOrImport">{t("yes")}</label>
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {selectedBank?.title === "مصرف بغداد" ? (
                  <div>
                    <span className={spanStyles}>{t("clickToDownload")}</span>
                    <ul>
                      <li>{t("confirmDocument")}</li>
                      <li>{t("moneyTransactionRequest")}</li>
                      <li>{t("declarationAndUndertaking")}</li>
                      <li>{t("financialTransferRequestForm")}</li>
                    </ul>
                  </div>
                ) : (
                  <div>
                    <span className={spanStyles}>{t("clickToDownload")}</span>
                    <ul>
                      <li>{t("transactionRequest")}</li>
                      <li>{t("entryRequest")}</li>
                      <li>{t("promise")}</li>
                    </ul>
                  </div>
                )}
              </div>
            </Modal>
          )}
        </div>
      </main>
    </>
  );
};

export default BankApplications;
